import debug from 'bows/dist/bows.min.js';
import imagesLoaded from 'imagesloaded';

const log = debug("grid");


function resizeGridItem(item) {
	if (document.querySelector(".grid")) {
		let grid = document.getElementsByClassName("grid")[0];
		let rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows')) || 20;
		let rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
		let rowSpan = Math.ceil((item.querySelector('.grid__content').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));
		item.style.gridRowEnd = "span " + rowSpan;
	}
}

function resizeAllGridItems() {
	let allItems = document.getElementsByClassName("grid__item");
	for (let x = 0; x < allItems.length; x++) {
		resizeGridItem(allItems[x]);
	}
}

function resizeInstance(instance) {
	let item = instance.elements[0];
	resizeGridItem(item);
}

export function init() {
	if (document.querySelector(".grid")) {

		resizeAllGridItems();
		window.addEventListener("resize", resizeAllGridItems);

		let allItems = document.getElementsByClassName("grid__item");
		for (let x = 0; x < allItems.length; x++) {
			imagesLoaded(allItems[x], resizeInstance);
		}
	}
	Drupal.behaviors.tpc_grid = {
		attach: (context, settings) => {

			if (context.querySelector(".grid")) {

				resizeAllGridItems();
				window.addEventListener("resize", resizeAllGridItems);

				let allItems = context.getElementsByClassName("grid__item");
				for (let x = 0; x < allItems.length; x++) {
					imagesLoaded(allItems[x], resizeInstance);
				}
			}
		}
	}
}

export default {
	init
};